<template>
	<div>
        <v-container fluid pa-0>
            <v-card elevation="0">
                <v-container fluid grid-list-xl class="toolbar-container">
                    <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                        <v-toolbar color="grey lighten-3" elevation="1">
                            <bc-btn-back></bc-btn-back>
                            <v-toolbar-title class="ml-0">{{$t($route.meta.title)}}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <bc-scan-barcode
                                v-if="hasPerm('batch.read')"
                                ref="scan_barcode"
                                scan-object="work_orders_batch"
                                header-text="Batch Lookup"
                                @scanned="routeFromBarcode($event)"
                                scan-label="i"
                                :global="true"
                            ></bc-scan-barcode>
                            <bc-btn-nonconformance
                                ref="nonconformance"
                                entity_object="work_orders_batch"
                                :entity_id="currObjField('batch_id')"
                            ></bc-btn-nonconformance>
                            <bc-modal-print
                                ref="print"
                                @close-method="file_name = null, $refs.print.close()"
                                :file-name="file_name"
                                :no-button="true"
                            ></bc-modal-print>
                            <bc-btn-add
                                @invoke-method="dev_mode ? showPrinter('print_4x6_label') : printLabel('print_4x6_label')"
                                icon="label"
                                :tooltip="$t('lang.label')"
                            ></bc-btn-add>
                            <bc-btn-add
                                @invoke-method="dev_mode ? showPrinter('print_process_sheet') : printLabel('print_process_sheet')"
                                icon="description"
                                :tooltip="$t('lang.print')"
                            ></bc-btn-add>
                            <bc-btn-refresh
                                @invoke-method="dbGetWorkOrder()"
                            ></bc-btn-refresh>
                            <bc-btn-mobile-nav
                                @invoke-method="invokeMethod($event)"
                                :mobile-list="mobileList"
                            ></bc-btn-mobile-nav>
                        </v-toolbar>
                    </v-layout>
                </v-container>
                <v-container grid-list-xl v-if="profile != null">
                    <v-layout row :wrap="$bp.smallScreen">
                        <v-flex xs12 md4 lg3 pb-0 :pl-0="!$bp.smallScreen" align-self-start>
                            <v-layout row wrap>
                                <v-flex xs8 py-0>
                                    <bc-tooltip right v-if="currObjField('has_incomplete_stations') == '1'" :disabled="!hasPerm('qc_inspection.create')">
                                        <template slot="activator">
                                            <v-btn
                                                v-if="hasPerm('qc_inspection.create')"
                                                style="max-width: 150px; text-transform: none;"
                                                class="pl-1"
                                                round
                                                selected
                                                :color="profile.qc_flag == '1' ? 'success' : 'grey'"
                                                text-color="white"
                                                @mouseup.left="dbMarkQCFlag()"
                                            >
                                                <v-icon color="white" class="mr-2" v-model="editStatus.qc_flag">{{status_loader ? "fas fa-circle-notch fa-spin" : profile.qc_flag == '1' ? 'check_circle' : 'control_point' }}</v-icon>
                                                <span class="white--text">{{ status_loader ? $t('lang.loading') : profile.qc_flag == '1' ? $t('lang.qc_enabled') : $t('lang.qc_disabled') }}</span>
                                            </v-btn>
                                            <v-chip v-else disabled round text-color="white" class="chip-padding-left-4 mr-auto fs-14" :color="profile.qc_flag == '1' ? 'success' : 'grey'">
                                                <span><v-icon class="mr-2">{{ profile.qc_flag == '1' ? 'check_circle' : 'control_point' }}</v-icon></span>
                                                <span class="white--text">{{ profile.qc_flag == '1' ? $t('lang.qc_enabled') : $t('lang.qc_disabled') }}</span>
                                            </v-chip>
                                        </template>
                                        {{ editStatus.qc_flag == "0" ? $t('lang.click_enable_qc') : $t('lang.click_disable_qc') }}
                                    </bc-tooltip>
                                    <bc-tooltip right v-else :disabled="!((hasPerm('qc_inspection.read') && profile.has_quality_control == '1' ) || (hasPerm('qc_inspection.create') && profile.has_quality_control == '0'))">
                                        <template slot="activator">
                                            <v-btn
                                                v-if="(hasPerm('qc_inspection.read') && profile.has_quality_control == '1' ) || (hasPerm('qc_inspection.create') && profile.has_quality_control == '0')"
                                                style="max-width: 150px; text-transform: none;"
                                                class="pl-1"
                                                round
                                                selected
                                                :color="profile.has_quality_control == '1' ? 'success' : 'grey'"
                                                text-color="white"
                                                @mouseup.left="profile.has_quality_control == '1' ? $refs.qc_dialog.showQualityControl(profile) : $refs.qc_dialog.selectBatch(profile)"
                                            >
                                                <v-icon color="white" class="mr-2">{{status_loader ? "fas fa-circle-notch fa-spin" : profile.has_quality_control == '1' ? 'edit' : 'control_point'}}</v-icon>
                                                <span class="white--text">{{ status_loader ? $t('lang.loading') : profile.has_quality_control == '1' ? 'View QC' : 'Add QC' }}</span>
                                            </v-btn>
                                            <v-chip v-else disabled round text-color="white" class="chip-padding-left-4 mr-auto fs-14" :color="profile.qc_flag == '1' ? 'success' : 'grey'">
                                                <span><v-icon class="mr-2">{{ profile.qc_flag == '1' ? 'check_circle' : 'control_point' }}</v-icon></span>
                                                <span class="white--text">{{ profile.has_quality_control == '1' ? 'Has QC' : 'No QC' }}</span>
                                            </v-chip>
                                        </template>
                                        {{ profile.has_quality_control == '1' ? 'Click to view/edit QC' : 'Click to add QC'  }}
                                    </bc-tooltip>
                                </v-flex>
                                <v-flex xs4 pr-0 py-0>
                                    <bc-tooltip class="ml-auto" perm="batch.update">
                                        <template slot="activator">
                                            <v-btn icon @mouseup.left="openBatchDialog()">
                                                <v-icon color="indigo">edit</v-icon>
                                            </v-btn>
                                        </template>
                                        {{ $t('lang.modify_batch') }}
                                    </bc-tooltip>
                                </v-flex>
                                <v-flex xs12 py-0>
                                    <v-img
                                        :src="(showErrorImg || (profile && !profile.photo)) ? errorImg : profile.photo"
                                        height="150px"
                                        width="150px"
                                        class="rounded-circle mx-auto"
                                        @error="showErrorImg = true"
                                    ></v-img>
                                </v-flex>
                                <v-flex py-0>
                                    <p class="display-1 mb-0 text-xs-center">{{ profile.name }}</p>
                                    <p
                                        :class="{ 'clickable primary--text underline-hover': hasPerm('parts.read') }"
                                        class="fs-22 mb-0 text-xs-center"
                                        @mouseup.left="hasPerm('parts.read') ? $router.push({ name: 'part_profile', params: { id: profile.part_id }}) : ''"
                                    >
                                        {{ profile.customer_part_number }}
                                    </p>
                                </v-flex>
                            </v-layout>
                            <v-divider class="my-0"></v-divider>
                            <bc-list prepend-icon="task" prepend-position="top" perm="batch.update" @invoke-method="openBatchDialog()">
                                <template>
                                    <v-container pa-2>
                                        <v-layout row wrap>
                                            <v-flex xs6 mt-1>{{ $t('lang.start_date') }}:</v-flex><v-flex xs6 fw-bold mt-1>{{ currObjField('start') ? currObjField('start').split(' ')[0] : '---' }}</v-flex>
                                            <v-flex xs6 mt-1>{{ $t('lang.start_time') }}:</v-flex><v-flex xs6 fw-bold mt-1>{{ currObjField('start') ? currObjField('start').split(' ')[1] : '---' }}</v-flex>
                                            <v-flex xs6 mt-1>{{ $t('lang.company') }}:</v-flex><v-flex xs6 fw-bold mt-1>{{ profile.company || '---' }}</v-flex>
                                            <v-flex xs6 mt-1>{{ $t('lang.batch_qty') }}:</v-flex><v-flex xs6 fw-bold mt-1>{{ profile.batch_size || '---' }}</v-flex>
                                            <v-flex xs6 mt-1>{{ $t('lang.dta_part_code') }}:</v-flex><v-flex xs6 fw-bold mt-1>{{ profile.dta_part_code || '---' }}</v-flex>
                                            <v-flex xs6 mt-1>{{ $t('lang.po_number') }}:</v-flex><v-flex xs6 fw-bold mt-1>{{ profile.po_number || '---' }}</v-flex>
                                            <v-flex xs6 mt-1>{{ $t('lang.lot_number') }}:</v-flex><v-flex xs6 fw-bold mt-1>{{ profile.lot_number || '---' }}</v-flex>
                                            <v-flex xs6 mt-1>{{ $t('lang.empty_box_location') }}:</v-flex><v-flex xs6 fw-bold mt-1>{{ profile.empty_box_location || '---' }}</v-flex>
                                        </v-layout>
                                    </v-container>
                                </template>
                            </bc-list>
                            <v-divider v-if="(profile.notes || []).length > 0" class="my-0"></v-divider>
                            <bc-notes-list
                                :items="profile.notes"
                                perm="batch.update"
                                entity-object="WorkOrder"
                                :api-url="`work_orders/${this.$route.params.work_order_id}/batches/${this.$route.params.batch_id}`"
                                :scope="profile.scope"
                                state-property="work_orders_batch.notes"
                            ></bc-notes-list>
                        </v-flex>
                        <v-divider vertical class="mt-0 mb-0" inset v-if="!$bp.smallScreen"></v-divider>
                        <v-flex xs12 md8 lg9 :pr-0="!$bp.smallScreen" align-self-start>
                            <div>
                                <bc-process @edit="openBatchDialog()" :key="update_process" ref="process"></bc-process>
                            </div>
                        </v-flex>
                    </v-layout>
		        </v-container>
            </v-card>
        </v-container>

        <bc-dialog :value="batch_dialog">
            <v-card>
                <v-card-title>
                    <span class="headline">{{ $t('lang.edit_batch') }}</span>
                    <v-spacer></v-spacer>
                    <bc-btn-dialog-close
                        @invoke-method="invokeMethod($event)"
                        dialog-model="batch_dialog"
                        :dialog-status="batch_dialog"
                    ></bc-btn-dialog-close>
                </v-card-title>
                <v-card-text>
                    <v-form ref="work_orders_batch">
                        <v-container grid-list-form>
                            <v-layout row wrap>
                                <v-flex xs6>
                                    <v-text-field
                                        v-focus="batch_dialog"
                                        v-model="edit_batch.jig_tag_number"
                                        :label="`${$t('lang.jig_tag_number')} *`"
                                        :counter="showCounter(edit_batch.jig_tag_number, 'work_orders_batch.jig_tag_number')"
                                        :rules="ifValid('work_orders_batch.jig_tag_number')"
                                        type="number"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs6>
                                    <v-text-field
                                        v-model="edit_batch.po_number"
                                        :label="$t('lang.po_number')"
                                        :counter="showCounter(edit_batch.po_number, 'work_orders_batch.po_number')"
                                        :rules="ifValid('work_orders_batch.po_number')"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs6>
                                    <v-text-field
                                        v-model="edit_batch.lot_number"
                                        :label="$t('lang.lot_number')"
                                        :counter="showCounter(edit_batch.lot_number, 'work_orders_batch.lot_number')"
                                        :rules="ifValid('work_orders_batch.lot_number')"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs6>
                                    <v-text-field
                                        v-model="edit_batch.empty_box_location"
                                        :label="$t('lang.empty_box_location')"
                                        :counter="showCounter(edit_batch.empty_box_location, 'work_orders_batch.empty_box_location')"
                                        :rules="ifValid('work_orders_batch.empty_box_location')"
                                    ></v-text-field>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn flat @mouseup.left="batch_dialog = false">{{$t('lang.cancel')}}</v-btn>
                    <v-btn color="success" @mouseup.left="modifyBatch('patch', currObjField('batch_id'))">{{$t('lang.save')}}</v-btn>
                </v-card-actions>
            </v-card>
        </bc-dialog>

        <bc-qc-dialog
            ref="qc_dialog"
            location="batch_profile"
        ></bc-qc-dialog>
	</div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { store } from "Store/store";
import AppConfig from "Constants/AppConfig";

import BcProcess from "Modules/manufacturing/work_orders/components/Process";
import BcQcDialog from "Modules/manufacturing/quality_control/components/QualityControlDialog";

export default {
    data() {
        return {
            dbGetWorkOrder: _.debounce(this.getWorkOrder, 1500, { maxWait: 1500, leading: true, trailing: false }),
            dbMarkQCFlag: _.debounce(this.markQCFlag, 1500, { maxWait: 1500, leading: true, trailing: false }),
            temp_stations: ["pre_wash", "furnace", "post_wash", "temper"],
            edit_batch: {
                lot_number: "",
                po_number: "",
                jig_tag_number: "",
                empty_box_location: "",
            },
            entity_note: {
                note: "",
            },
            editStatus: { qc_flag: "" },
            status_loader: false,
            start_time: null,
            start_date: null,
            slug_group: {},
            filtered_group: {},
            station_options: [],
            file_name: null,
            batch_dialog: false,
            refresh: 0,
            update_process: 0,
            errorImg: AppConfig.baseApiUrl + "/public/default_part.png",
            showErrorImg: false,
            tableLoader: false,
            growText: 0,
        };
    },
    computed: {
        ...mapState({
            rules_work_orders_batch: (state) => state.validation.rules_work_orders_batch,
            profile: (state) => state.work_orders.work_orders_batch,
            part_stations: (state) => state.work_orders.part_stations,
            rules_entity_note: (state) => state.validation.rules_entity_note,
        }),
        currObjField() {
            return (field) => {
                return this.profile && field && this.profile[field] ? this.profile[field] : "";
            };
        },
        mobileList() {
            let modifylist = [
                { title: this.$t("lang.create_nonconformance"), action: "showNonconformance", ref: "nonconformance", perms: ["nonconformance.create"] },
                { title: this.$t("lang.print_label"), action: this.dev_mode ? "showPrinter" : "printLabel", params: ["print_4x6_label"] },
                { title: this.$t("lang.print_process_sheet"), action: this.dev_mode ? "showPrinter" : "printLabel", params: ["print_process_sheet"] },
                { title: this.$t("lang.refresh"), action: "dbGetWorkOrder" },
            ];

            return modifylist;
        },
    },
    beforeRouteEnter(to, from, next) {
        const work_orders_batch = new Promise((resolve, reject) => {
            store
                .dispatch("fetchWorkOrder", {
                    url: `work_orders/${to.params.work_order_id}/batches/${to.params.batch_id}`,
                    method: "get",
                    stateProperty: "work_orders_batch|part_stations",
                    commit: true,
                })
                .then((data) => {
                    typeof data !== "undefined" && data.work_orders_batch ? resolve(data.work_orders_batch) : reject(new Error("reject"));
                });
        });

        Promise.all([work_orders_batch])
            .then(([work_orders_batch]) => {
                next((vm) => {
                    vm.editStatus = { qc_flag: work_orders_batch.qc_flag };
                    vm.$store.commit("toggleModalLoader", false);
                    vm.finishLoader();
                    vm.$store.commit("toggleGlobalSnackbar", false);
                });
            })
            .catch((error) => {
                next({ name: "dashboard", replace: true }); //if any of them error, don't go to route, else set variables and proceed to route
            });
    },
    beforeRouteUpdate(to, from, next) {
        const work_orders_batch = new Promise((resolve, reject) => {
            store
                .dispatch("fetchWorkOrder", {
                    url: `work_orders/${to.params.work_order_id}/batches/${to.params.batch_id}`,
                    method: "get",
                    stateProperty: "work_orders_batch|part_stations",
                    commit: true,
                })
                .then((data) => {
                    typeof data !== "undefined" && data.work_orders_batch ? resolve(data.work_orders_batch) : reject(new Error("reject"));
                });
        });

        Promise.all([work_orders_batch])
            .then(([work_orders_batch]) => {
                this.editStatus = { qc_flag: work_orders_batch.qc_flag };
                this.$store.commit("toggleModalLoader", false);
                this.finishLoader();
                this.$store.commit("toggleGlobalSnackbar", false);
                next();
            })
            .catch((error) => {
                next({ name: "dashboard", replace: true }); //if any of them error, don't go to route, else set variables and proceed to route
            });
    },
    methods: {
        addNote() {
            this.$refs.noteDialog.setNote({ ...this.entity_note });
            this.$refs.noteDialog.modifyEntityNote("post");
            this.entity_note.note = "";
            this.growText++;
        },
        getSchedule() {
            this.station_options = [];
            let slug_group = {};
            if (this.part_stations) {
                for (const [key, value] of Object.entries(this.part_stations)) {
                    if (this.part_stations[key].length == 0) {
                        delete this.part_stations[key];
                    } else {
                        let group = this.part_stations[key].filter((e) => e.selected == "1")[0];
                        if (!group) {
                            group = this.part_stations[key].filter((e) => e.selected == "0")[0];
                        }
                        this.station_options.push(group.part_station_id);
                        slug_group[group.slug] = this.part_stations[key];
                    }
                }
            }
            this.slug_group = slug_group;
        },
        showPrinter(type) {
            // this.startLoader();
            if (this.profile) {
                this.$refs.print.openDialog();

                this.$store
                    .dispatch("fetchWorkOrder", {
                        url: `work_orders/batches/${type}`,
                        method: "get",
                        body: {
                            batch_id: this.profile.batch_id,
                        },
                    })
                    .then((data) => {
                        if (typeof data != "undefined" && data.process_sheet) {
                            this.file_name = data.process_sheet.file_name;
                        } else if (typeof data != "undefined" && data.bill_of_lading) {
                            this.file_name = data.bill_of_lading.file_name;
                        } else {
                            this.file_name = "";
                            this.$refs.print.close();
                            this.createAlert();
                        }
                    });
            }
        },
        printLabel(type) {
            this.$store.commit("toggleGlobalSnackbar", true);
            this.$store
                .dispatch("fetchWorkOrder", {
                    url: `work_orders/batches/${type}`,
                    method: "get",
                    body: {
                        batch_id: this.profile.batch_id,
                    },
                })
                .then((data) => {
                    if (typeof data != "undefined" && data.process_sheet) {
                        this.$refs.print.printReport(data.process_sheet.file_name);
                    } else if (typeof data != "undefined" && data.bill_of_lading) {
                        this.$refs.print.printReport(data.bill_of_lading.file_name);
                    } else {
                        this.createAlert();
                    }
                    this.$store.commit("toggleGlobalSnackbar", false);
                });
        },
        openBatchDialog() {
            if (this.currObjField("date_scheduled")) {
                let temp_date = this.currObjField("date_scheduled").split(" ");
                this.start_date = temp_date[0];
                this.start_time = temp_date[1];
            }
            this.getSchedule();
            this.assignObj(this.edit_batch, this.profile);
            this.batch_dialog = true;
        },
        getWorkOrder(status = true) {
            if (status) this.startLoader();
            this.$store
                .dispatch("fetchWorkOrder", {
                    url: `work_orders/${this.$route.params.work_order_id}/batches/${this.$route.params.batch_id}`,
                    method: "get",
                    stateProperty: "work_orders_batch|part_stations",
                    commit: true,
                })
                .then((data) => {
                    if (typeof data == "undefined" || !data.work_orders_batch) {
                        this.$router.push({ name: "continuous_production" });
                    } else {
                        this.editStatus = { qc_flag: data.work_orders_batch.qc_flag };
                        this.$refs.process.setGroups();
                    }
                })
                .finally(() => {
                    this.$nextTick(() => {
                        this.finishLoader(true);
                    });
                });
        },
        modifyBatch(method = null, id = null) {
            if (method) {
                this.$store.commit("validationOn");
                this.$nextTick(() => {
                    if (this.validateForm("work_orders_batch")) {
                        this.$store.commit("toggleModalLoader", true);
                        this.$store
                            .dispatch("fetchWorkOrder", {
                                pk: "batch_id",
                                id: id,
                                url: `work_orders/${this.currObjField("work_order_id")}/batches/${id ? id : ""}`,
                                method: method,
                                stateProperty: "work_orders_batch",
                                commit: true,
                                body: this.edit_batch,
                            })
                            .then((data) => {
                                if (data && data.code == "200") {
                                    this.batch_dialog = false;
                                    this.update_process++;
                                }
                                this.$store.commit("toggleModalLoader", false);
                            });
                    }
                });
            }
        },
        markQCFlag() {
            this.status_loader = true;
            this.profile.qc_flag == "1" ? (this.editStatus.qc_flag = "0") : (this.editStatus.qc_flag = "1");
            this.$store
                .dispatch("fetchWorkOrder", {
                    url: `work_orders/continuous/${this.$route.params.work_order_id}/batch/${this.$route.params.batch_id}/qc`,
                    method: "patch",
                    stateProperty: "work_orders_batch",
                    commit: true,
                    body: this.editStatus,
                })
                .then((data) => {
                    this.status_loader = false;
                    this.finishLoader();
                    if (!data) {
                        this.editStatus.qc_flag = this.profile.qc_flag == "1";
                    }
                });
        },
        routeFromBarcode(barcode) {
            if (barcode.work_order_id != this.$route.params.work_order_id || barcode.batch_id != this.$route.params.batch_id) {
                this.$router.push({ name: "batch_profile", params: { work_order_id: barcode.work_order_id, batch_id: barcode.batch_id } });
            } else {
                this.createAlert("error", "already_at_batch");
                this.$store.commit("toggleGlobalSnackbar", false);
            }
        },
    },
    components: {
        BcProcess,
        BcQcDialog,
    },
};
</script>
